import Area from '@/store/model/main/Area'
import Provider from '@/store/model/import/Provider'
import Sport from './Sport'

export default class Competition {
  constructor (data) {
    this.id = data.id
    this.areaId = data.areaId
    this.providerId = data.providerId
    this.sportId = data.sportId
    this.nameFr = data.nameFr
    this.shortnameEn = data.shortnameEn

    this.sport = data.sport ? new Sport(data.sport) : null
    this.provider = data.provider ? new Provider(data.provider) : null
    this.area = data.area ? new Area(data.area) : null
  }
}
